import Tooltip from '@ingka/tooltip';
import { useTranslation } from 'react-i18next';
import Button from '@ingka/button';
import information from '@ingka/ssr-icon/paths/information-circle';
import { APIPath } from './types';
import classes from './FileUpload.module.scss';

export const FileUploadPanelWrapper = ({
    heading,
    description,
    children,
    apiType,
    disabled
}: {
    heading: string;
    description: string;
    children: React.ReactNode;
    apiType?: APIPath;
    disabled?: boolean;
}) => {
    const { t } = useTranslation();
    const showBudgetHoursDisabledTooltip = disabled && apiType === APIPath.BUDGET_HOURS;

    return (
        <div data-testid={`file-upload-heading--${heading}`} className={classes.column}>

            <div className={classes.heading}>
                {heading}
                {showBudgetHoursDisabledTooltip && (
                    <Tooltip describedById="budget-hours-icon-tooltip" position="trailing" tooltipText={t('BUDGET_HOURS_DISABLED_TOOLTIP')}>
                        <Button
                            id="budget-hours-icon"
                            data-testid="budget-hours-icon"
                            ssrIcon={information}
                            type="tertiary"
                            iconOnly
                            size="xsmall"
                            aria-label={t('BUDGET_HOURS_DISABLED_TOOLTIP')}
                        />
                    </Tooltip>
                )}
            </div>
            <div data-testid={`file-upload-description--${heading}`} className={classes.description}>
                {description}
            </div>
            {children}
        </div>
    );
};
